import { Check } from 'lucide-react';
import * as RPNInput from 'react-phone-number-input';
import { PLUS_SIGN } from '@sib/config';
import { CommandItem } from '../Command';
import { FlagComponent } from './FlagComponent';
import { CountrySelectOptionProps } from './types';

export const CountrySelectOption = ({
  country,
  countryName,
  selectedCountry,
  onChange,
  onSelectComplete,
}: CountrySelectOptionProps) => {
  const handleSelect = () => {
    onChange(country);
    onSelectComplete();
  };

  return (
    <CommandItem className="gap-2" onSelect={handleSelect}>
      <FlagComponent country={country} countryName={countryName} />
      <span className="flex-1 text-sm">{countryName}</span>
      <span className="text-foreground/50 text-sm">
        {`${PLUS_SIGN}${RPNInput.getCountryCallingCode(country)}`}
      </span>
      <Check
        className={`ml-auto size-4 ${country === selectedCountry ? 'opacity-100' : 'opacity-0'}`}
      />
    </CommandItem>
  );
};
